import { Link } from "react-router-dom";
import type { Product } from "@/mocks/products";
import { useUserPrice } from "@/hooks/useUserPrice";

interface ProductCardProps {
  product: Product;
}

export default function ProductCard({ product }: ProductCardProps) {
  const { getPrice, getProfitRate } = useUserPrice();
  const price = getPrice(product);
  const profitRate = getProfitRate(product);

  return (
    <Link
      to={`/products/${product.id}`}
      className="group bg-white rounded-xl overflow-hidden border border-gray-100 hover:border-amber-200 hover:shadow-md transition-all duration-300 cursor-pointer block"
    >
      <div className="relative aspect-square overflow-hidden bg-gray-50">
        <img
          src={product.images[0]}
          alt={product.name}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2 flex flex-col gap-1">
          {product.isHot && (
            <span className="bg-red-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">爆款</span>
          )}
          {product.isNew && (
            <span className="bg-emerald-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">新品</span>
          )}
          {product.isOnSale && (
            <span className="bg-amber-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">促銷</span>
          )}
        </div>
        <div className="absolute top-2 right-2 bg-black/60 text-amber-400 text-xs px-2 py-0.5 rounded-full font-medium">
          利潤 {profitRate}%
        </div>
      </div>
      <div className="p-4">
        <p className="text-gray-800 text-sm font-medium line-clamp-2 leading-snug mb-2">{product.name}</p>
        <div className="flex flex-wrap gap-1 mb-2">
          {product.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="text-xs text-gray-400 bg-gray-50 px-1.5 py-0.5 rounded">
              {tag}
            </span>
          ))}
        </div>
        <div className="flex items-end justify-between">
          <div className="min-w-0 flex-1">
            <div className="text-amber-600 font-bold text-lg">認購價：${price.toLocaleString('zh-TW')}</div>
            <div className="text-gray-400 text-xs truncate">銷售 ${Number(product.suggestedPrice).toLocaleString('zh-TW')}</div>
          </div>
          {product.stock <= 0 ? (
            <div className="text-xs text-red-500 font-medium">已售完</div>
          ) : (
            <div className="text-xs text-gray-400">庫存 {product.stock}</div>
          )}
        </div>
      </div>
    </Link>
  );
}